import { useEffect, useState } from "react";
import Image from "next/image";
import AOS from "aos";
import "aos/dist/aos.css";
import ImTicon from "../../assets/images/Tnpsc/ImTopIcon-02.png";
import styles from "./demo.module.css";

const DemoTestPage = () => {
  const questions = [
    {
      text: "The movement led by Ishwar Chandra Vidyasagar resulted in the passing of which of the following significant legislations?",
      options: [
        "The Abolition of Sati Act of 1829",
        "The Age of Consent Act of 1891",
        "The Widow’s Remarriage Reform Act of 1856",
        "The Native Marriage Act of 1872"
      ],
      correct: 2,
      explanation:
        "His movement = Widows got the right to remarry (Hindu Widows' Remarriage Act, 1856)."
    },
    
    {
      text: (<> <p>Consider the following statements regarding the Arya Samaj? <br/>
                   I. It was founded in the year 1835.<br/>

                   II. It opposed superstitious practices in Hinduism.<br/>

                   III. It advocated a return to the teachings of the Vedas.<br/>

                   Which of the statements given above is/are correct?</p></>),

      options: ["I and III only", 
                "II and III only", 
                "III only", 
                "I, II and III"],
      correct: 1,
      explanation:
        "Arya Samaj wanted people to leave wrong practices and follow true Vedic knowledge. So, Statements II and III are correct"
    },
    {
      text: "What is the capital of Tamil Nadu?",
      options: ["Madurai", "Coimbatore", "Chennai", "Trichy"],
      correct: 2,
      explanation:
        "Chennai is the capital city of Tamil Nadu."
    }
  ];

  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const handleOptionClick = (index) => {
    if (selected !== null) return;

    setSelected(index);
    setShowAnswer(true);

    if (index === questions[current].correct) {
      setScore(score + 1);
    }
  };

  const handleNext = () => {
    if (current + 1 < questions.length) {
      setCurrent(current + 1);
      setSelected(null);
      setShowAnswer(false);
    } else {
      setFinished(true);
    }
  };

  const handleRestart = () => {
    setCurrent(0);
    setSelected(null);
    setShowAnswer(false);
    setScore(0);
    setFinished(false);
  };

  if (finished) {
    return (
       <div className={styles.cardBox}>
      <div className={styles.container}>
        <h2>Test Completed 🎉</h2>
        <h3>Your Score: {score} / {questions.length}</h3>
        <button onClick={handleRestart} className={styles.nextBtn}>
          Restart
        </button>

        <div className={styles.payBox}>
          <p className={`${styles.payText} pt-3 text-center` }>
            Want full test series with detailed analysis?
          </p>

          <a
            href="https://admissionsv1.shankariasacademy.com/?center=Anna_Nagar&coursetype=TNPSC"
            target="_blank"
          >
            <button className={`${styles.payBtn}`}>
              👉 Pay Now
            </button>
          </a>
        </div>
      </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className={styles.cardBox}>
        <div className={styles.container}>
          <div className={styles.header}>
            {/* <Image src={ImTicon} width={60} height={60} alt="icon" /> */}
            <h1 className="pt-2">TNPSC  Demo Test</h1>
          </div>

            <h3 className={`${styles.header3} pt-2`}>{questions[current].text}</h3>

          <div className={styles.optionsGrid}>
            {questions[current].options.map((opt, index) => {
              let className = styles.optionCircle;

              if (showAnswer) {
                if (index === questions[current].correct) {
                  className += " " + styles.correct;
                } else if (index === selected) {
                  className += " " + styles.wrong;
                }
              }

              return (
                <button
                  key={index}
                  className={className}
                  onClick={() => handleOptionClick(index)}
                  disabled={selected !== null}
                >
                  <span className={styles.label}>
                    {String.fromCharCode(65 + index)}
                  </span>

                  <span className={styles.text}>{opt}</span>

                  {showAnswer && index === questions[current].correct && (
                    <span className={styles.tick}>✔</span>
                  )}

                  {showAnswer &&
                    index === selected &&
                    index !== questions[current].correct && (
                      <span className={styles.cross}>✖</span>
                    )}
                </button>
              );
            })}
          </div>

            <p className="pt-3">Question {current + 1} / {questions.length}</p>

            {showAnswer && (
              <div className={styles.explanation}>
                <strong>Explanation:</strong>{" "}
                {questions[current].explanation}
              </div>
            )}

            {showAnswer && (
              <button className={styles.nextBtn} onClick={handleNext}>
                Next
              </button>
            )}
          
        </div>
      </div>
    </div>
  );
};
export default DemoTestPage;